import {
  Directive,
  Output,
  EventEmitter,
  ElementRef,
  Input,
  NgZone,
} from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { Content } from 'ionic-angular';
import { ToolsProvider } from '../../providers/tools/tools';

/**
 * Generated class for the ScrollWatchDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[scrollWatch]',
  exportAs: 'scroll-watch',
})
export class ScrollWatchDirective {
  log = debug('debug:app:ScrollWatchDirective');

  @Input() scrollContainer: String;
  @Input() unsubscribeOnExit = false;
  @Input() scrollCloseThreshold = window.innerHeight * 2;
  @Output() scrollClose = new EventEmitter();
  @Output() scrollEnter = new EventEmitter();
  @Output() firstEnter = new EventEmitter();
  @Output() scrollExit = new EventEmitter();
  @Output() middleEnter = new EventEmitter();
  @Output() whereAmI = new EventEmitter();

  hasBeenClose = false; // has the element been close to entering the viewport
  hasEntered = false; // has the element entered the viewport
  enterTime;
  isInViewPort = false; // is the element current in the viewport
  seenMiddle = false; // has seen the middle of the div to mark analytics
  middleIsInView = false;
  subs = [];
  _parent;
  _parentIsContent = true;
  _lastCheck = 0;

  constructor(
    public element: ElementRef,
    private content: Content,
    public zone: NgZone,
    public tools: ToolsProvider
  ) {
    // this.log('constructed', this.element, this.content);
    this.log('constructed', this.scrollCloseThreshold);
  }

  ngOnInit() {
    this.start();
  }

  start() {
    const parent = (this._parent = this.getScrollParent(
      this.element.nativeElement
    ));

    this.log('init', parent);
    if (!parent || !(parent instanceof Element)) return;

    setTimeout(() => {
      this.checkClose();
    });

    let fn = () => {
      this.onScroll();
    };

    if (parent.classList.contains('scroll-content')) {
      // use this.content
      // this.log('use scroll parent');
      this.subs.push(this.content.ionScroll.subscribe(fn));
      this._parentIsContent = true;
    } else {
      // custom watch
      // this.log('custom watch');
      parent.addEventListener('scroll', fn);
      this.subs.push(() => {
        parent.removeEventListener('scroll', fn);
      });
      this._parentIsContent = false;
    }
  }

  onScroll() {
    const ts = new Date().getTime();

    if (this._lastCheck + 500 > ts) {
      // this.log('too recent');
      // no need to check less than every XXms
      return 2;
    }
    this._lastCheck = ts;

    this.log('on scroll', this.element.nativeElement);

    try {
      const rect = this.getRect();

      const inView = this.isCurrentlyInView(rect);
      const middleIsInView = this.isMiddleCurrentlyInView(rect);

      this.checkClose(rect);

      if (inView) {
        if (!this.hasEntered) {
          this.hasEntered = true;
          this.firstEnter.emit();
          this.enterTime = ts;
        }
        this.isInViewPort = true;
        this.whereAmI.emit('in-view');
        this.scrollEnter.emit();
      } else if (this.isInViewPort) {
        this.isInViewPort = false;
        this.whereAmI.emit('not-in-view');
      }
      if (middleIsInView && !this.seenMiddle) {
        this.seenMiddle = true;
        this.middleEnter.emit();
      } else if (!middleIsInView && this.middleIsInView) {
        const exitTime = new Date().getTime();
        const timeInView = exitTime - this.enterTime;
        // exited
        this.scrollExit.emit(timeInView);

        if (this.unsubscribeOnExit) {
          this.unsubscribeEvents();
        }
      }

      this.middleIsInView = middleIsInView;
    } catch (e) {}
  }

  getScrollParent(node) {
    if (!node) {
      return null;
    }

    if (!(node instanceof Element)) {
      return null;
    }

    const o = window.getComputedStyle(node).overflowY;
    if (o === 'auto' || o === 'scroll') {
      return node;
    } else {
      return this.getScrollParent(node.parentNode);
    }
  }

  getRect() {
    if (this.scrollContainer) {
      try {
        const el = $(this.element.nativeElement)
          .find(this.scrollContainer)
          .get(0);
        return el.getBoundingClientRect();
      } catch (e) {
        return this.element.nativeElement.getBoundingClientRect();
      }
    } else {
      return this.element.nativeElement.getBoundingClientRect();
    }
  }

  isMiddleCurrentlyInView(rect) {
    try {
      const maxY = window.innerHeight || document.documentElement.clientHeight;

      const middleY = rect.top + rect.height / 2;
      return middleY >= 0 && middleY < maxY && middleY >= 0 && middleY < maxY;
    } catch (e) {
      return false;
    }
  }

  checkClose(rect?) {
    if (!this.hasBeenClose && this.isClose(rect || this.getRect())) {
      this.hasBeenClose = true;
      this.zone.run(() => {
        this.scrollClose.emit(true);
        this.whereAmI.emit('is-close');
      });
    }
  }

  isClose(rect) {
    const maxY = window.innerHeight || document.documentElement.clientHeight;

    // scrollClose can't be zero

    if (Math.abs(rect.top) - (this.scrollCloseThreshold || 500) <= maxY) {
      return true;
    }
  }

  isCurrentlyInView(rect) {
    // For now, only looking at top/bottom comparison
    try {
      let maxY = window.innerHeight || document.documentElement.clientHeight;

      const top = Math.abs(rect.top);
      const bottom = Math.abs(rect.bottom);
      return top >= 0 && top < maxY && bottom >= 0 && bottom < maxY;
    } catch (e) {
      return false;
    }
  }

  unsubscribeEvents() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribeEvents();
  }
}



// WEBPACK FOOTER //
// ./src/directives/scroll-watch/scroll-watch.ts